import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { Button, TextField } from '@/DesignSystem/Component';
interface Props {
  controlCode: Control<any>;
  onSubmit: () => void;
  disabled: boolean;
  discountApplied: boolean;
  removeDiscount?: () => void;
}
const SubscriptionDiscountForm: FC<Props> = ({
  controlCode,
  onSubmit,
  disabled,
  discountApplied,
  removeDiscount
}) => {
  return <>
      <div className="mr-8 pt-1 text-sm font-medium text-blackThree">کد تخفیف خود را وارد کنید.</div>
      <form onSubmit={onSubmit} className="relative flex w-full flex-col bg-white py-4">
        <div className="relative flex flex-row items-center pb-6">
          <TextField control={controlCode} type="string" className="ml-2 h-9 flex-1 text-lg placeholder:!text-blueFive" label="کد تـخـفیــف ..." name="code" color="light" data-sentry-element="TextField" data-sentry-source-file="SubscriptionDiscountForm.tsx" />
          <Button className="-mb-1 !h-[40px] !rounded-lg text-sm font-bold" color="blueN" type="submit" variant="contained" disabled={disabled} data-sentry-element="Button" data-sentry-source-file="SubscriptionDiscountForm.tsx">
            اعمال تخفیف
          </Button>
        </div>
        {discountApplied && <div className="absolute bottom-0 right-0 flex flex-row items-center">
            <div className="text-sm text-greenFour">تخفیف با موفقیت اعمال شد!</div>
            <Button className="mr-10 !h-auto !rounded-none border-b-2 border-blackThree !p-0 text-sm text-blackThree" onClick={removeDiscount} type="button">
              حذف تخفیف!
            </Button>
          </div>}
      </form>
    </>;
};
export default SubscriptionDiscountForm;